/** @jsxImportSource @emotion/react */

import { Spin } from "antd";
import { AnnouncementApi } from "api/announcement";
import { ResponseCode } from "contants/response";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import { BannerStyle } from "./index.style";
function Banner() {
  const sliderRefAbove = useRef<Slider | null>(null);
  const [bannerList, setBannerList] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getBanner = async () => {
      try {
        const response = await AnnouncementApi.getBanner();

        if (response.status !== ResponseCode.SUCCESS) return;

        setBannerList(response.data.map((item) => item.web_banner));
      } catch (error) {
        //
      } finally {
        setIsLoading(false);
      }
    };

    getBanner();
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 250,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    dots: true,
  };

  if (isLoading) {
    return (
      <div css={BannerStyle.loading}>
        <Spin />
      </div>
    );
  }

  if (!bannerList.length) return null;

  return (
    <div css={BannerStyle.index}>
      <Slider {...settings} ref={sliderRefAbove}>
        {bannerList.map((item, index) => {
          return (
            <section css={BannerStyle.banner} key={`key-${index}-slider`}>
              <img
                onClick={() => sliderRefAbove.current?.slickNext()}
                src={item}
                alt=""
              />
            </section>
          );
        })}
      </Slider>
    </div>
  );
}

export default Banner;
